import React from 'react';
import TabContainer from '../../components/TabContainer';
//import LogoFaturalarPage from '../logo/LogoFaturalarPage';
import LogoSenkronizasyonPage from '../logo/LogoSenkronizasyonPage';
import LogoFaturaOnizlemePage from '../logo/LogoFaturaOnizlemePage';
import EslestirmeMerkeziPage from '../entegrasyon/EslestirmeMerkeziPage';

const EntegrasyonPage = () => {
  
  const tabs = [
    //{ id: 'logo-faturalar', label: 'İşbaşı Faturalar', icon: '📄', component: <LogoFaturalarPage /> },
    { id: 'logo-senk', label: 'Fatura Senkronizasyonu', icon: '🔄', component: <LogoSenkronizasyonPage /> },
    { id: 'logo-onizleme', label: 'Fatura Önizleme', icon: '👁️', component: <LogoFaturaOnizlemePage /> },
    { id: 'eslestirme', label: 'Eşleştirme Merkezi', icon: '🔗', component: <EslestirmeMerkeziPage /> },
    
  ];
  return <TabContainer title="Entegrasyon" tabs={tabs} defaultTab="logo-senk" />;
};

export default EntegrasyonPage;
